import { createFileRoute } from "@tanstack/react-router";
import AdminPricing from "@/pages/admin/AdminPricing";

export const Route = createFileRoute("/_adminLayout/admin/pricing")({
  validateSearch: (search: Record<string, unknown>) => ({
    stock: typeof search['stock'] === "string" ? search['stock'] : undefined,
    returnSlug: typeof search['returnSlug'] === "string" ? search['returnSlug'] : undefined,
    returnPreview: search['returnPreview'] === true,
    returnTheme: typeof search['returnTheme'] === "string" ? search['returnTheme'] : undefined,
  }),
  head: () => ({ meta: [
    { title: "Pricing Intelligence | Rex & Sons RVs Admin" },
    { name: "description", content: "Review competitor RV pricing, market benchmarks and listing aging for Rex & Sons inventory." },
    { property: "og:title", content: "Pricing Intelligence | Rex & Sons RVs Admin" },
    { property: "og:description", content: "Review competitor RV pricing, market benchmarks and listing aging for Rex & Sons inventory." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
  ] }),
  component: AdminPricing,
});
